<ng-select [items]="options"
           bindLabel="label"
           bindValue="value"
           [groupBy]="optGroupEnabled ? 'groupValue' : null"
           [placeholder]="placeholder"
           [markFirst]="false"
           (change)="internalOnChange($event)"
           (clear)="internalOnClear()"
           [(ngModel)]="value"
           [readonly]="readonly"
           [loading]="loading"
           [virtualScroll]="virtualScroll"
           class="form__searchableSelect"
           [class]="cssClasses"
           [class.read-only]="readonly"
           [class.form__input--small]="small"
           [multiple]="multiple"
           [selectableGroup]="selectableGroup"
           [class.required]="touched && invalid"
           [clearable]="clearable"
           [compareWith]="compareFn"
           (focus)="focus.emit()"
           [appendTo]="appendTo"
           [searchFn]="searchFn"
           #searchableDropdown>
    <ng-template *ngIf="optGroupEnabled && optGroupTranslationLookup" ng-optgroup-tmp let-item="item">
        {{ item.groupValue !== null && item.groupValue !== undefined  ? optGroupTranslationLookup[item.groupValue] || optGroupTranslationMissingLabel : optGroupValueEmptyLabel }}
    </ng-template>
    <ng-template *ngIf="optGroupEnabled && !optGroupTranslationLookup" ng-optgroup-tmp let-item="item">
        {{ item.groupValue !== null && item.groupValue !== undefined ? item.groupValue : optGroupValueEmptyLabel }}
    </ng-template>
    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
        <div class="ng-value" *ngFor="let item of items | slice:0:multipleShown">
            <span *ngIf="item.label" class="ng-value-label">{{item.label}}</span>
            <span *ngIf="!item.label && optGroupEnabled && optGroupTranslationLookup" class="ng-value-label">
                {{ item.groupValue !== null && item.groupValue !== undefined  ? optGroupTranslationLookup[item.groupValue] || optGroupTranslationMissingLabel : optGroupValueEmptyLabel }}
            </span>
            <span *ngIf="!item.label && optGroupEnabled && !optGroupTranslationLookup"  class="ng-value-label">
                {{ item.groupValue !== null && item.groupValue !== undefined ? item.groupValue : optGroupValueEmptyLabel }}
            </span>
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
        </div>
        <div class="ng-value" *ngIf="items.length > multipleShown">
            <span class="ng-value-label">{{items.length - multipleShown}} more...</span>
        </div>
    </ng-template>
</ng-select>
